<template>
	<div>


		<div class="main-header">
			<div class="container">
				<h2 class="main-header-text">Change Email</h2>
			</div>
		</div>
		<!-- eo main header -->


		<div class="main-section mgt-40">
			<div class="container">

				<div class="main-card">
					<img src="/static/img/icons/arrow-down-indicator-red.png" alt="" class="top-indicator" />

					<div class="row">
						<div class="col-lg-8">
							<form @submit.prevent="onSubmit" novalidate="" autocomplete="off">
								<div class="form-card">
									<div class="form-card-header">
										<h3>Personal Details</h3>
									</div>

									<div class="form-card-forms">

										<div class="row">

											<div class="col-lg-6">
												<div class="form-group">
													<label for="">
														Enter New Email<span class="required">*</span>
													</label>
													<input type="text" class="form-control" id="NewEmail" placeholder="New Email"
																 name="NewEmail"
																 autocomplete="off"
																 v-model="vModel.NewEmail"
																 data-vv-as='New email'
																 v-validate="'required|email'"
																 :class="{'input': true, 'is-danger': errors.has('NewEmail') }" />
													<div v-show="errors.has('NewEmail')"
															 class="help is-danger">
														{{ errors.first('NewEmail') }}
													</div>
												</div>
											</div>

										</div>

										<div class="row">

											<div class="col-lg-6">
												<div class="form-group">
													<label for="">
														Confirm New Email<span class="required">*</span>
													</label>
													<input type="text" class="form-control" id="ConfirmEmail" placeholder="Confirm  Email"
																 name="ConfirmEmail"
																 autocomplete="off"
																 v-model="vModel.ConfirmEmail"
																 data-vv-as='Confirm new email'
																 v-validate="'required|confirmed:NewEmail'"
																 :class="{'input': true, 'is-danger': errors.has('ConfirmEmail') }" />
													<div v-show="errors.has('ConfirmEmail')"
															 class="help is-danger">
														{{ errors.first('ConfirmEmail') }}
													</div>
												</div>
											</div>

										</div>

									</div>
									<!-- eo form card forms -->
								</div>
								<!-- eo form card -->

								<div class="submit-option">
									<div class="left-option">
										<router-link :to="'/dashboard'" class="btn submit-lefticon-btn">
											<span class="left-icon">
												<i class="material-icons">chevron_left</i>
											</span>
											<span class="btn-content">Cancel</span>
										</router-link>
									</div>

									<div class="right-option">
										<button class="btn submit-lefticon-btn">
											<span class="left-icon">
												<i class="material-icons">mail</i>
											</span>
											<span class="btn-content">Save Email</span>
										</button>
									</div>
								</div>
							</form>
						</div>
						<!-- eo col-8 -->

						<div class="col-lg-4">
							<UserDetailSection />
						</div>
					</div>
					<!-- eo row -->

				</div>
				<!-- eo main card -->

			</div>
			<!-- eo container -->
		</div>
		<!-- eo main section -->
	</div>
</template>
<script>
	import Base from "../../shared/Base.vue";
	import CommonService from "../../services/common";
	import UserDetailSection from "../../shared/UserDetailSection.vue";
	export default {
		name: "ChangeEmail",
		extends: Base,
		components: { UserDetailSection },
		beforeRouteEnter(to, from, next) {
			next();
		},

		methods: {
			onSubmit() {
				var self = this;
				if (self.isProcessing) return;

				self.$validator.validateAll().then(result => {
					if (result) {
						var url = "account/email/change";
						self.isProcessing = true;
						self.$http.post(url, self.vModel).then(
							response => {
								self.$toastr(
									"success",
									"Email changed successfully. Please check your inbox for more detail."
								);
								self.isProcessing = false;

								if (window._sessionInterval != null) {
									clearInterval(window._sessionInterval);
								}
								CommonService.destroyStorage();
								self.$router.push("/account/login");
							},
							error => {
								self.isProcessing = false;
							}
						);
					}
				});
			}
		},
		data() {
			return {
				vModel: {
					NewEmail: null,
					ConfirmEmail: null,
					Password: null
				}
			};
		}
	};
</script>

